import { useSearchParams } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { newsPage } from "@/content/site";
import { newsFilters, newsItems } from "@/content/news";
import usePageMeta from "@/hooks/usePageMeta";
import { PageHero } from "@/components/sections/PageHero";
import { NewsCard } from "@/components/sections/NewsCard";
import { CtaBand } from "@/components/sections/CtaBand";
import { FilterTabs } from "@/components/common/FilterTabs";

const IDS = newsFilters.map((f) => f.id);
const countFor = (id) => (id === "all" ? newsItems.length : newsItems.filter((n) => n.category === id).length);

export default function News() {
  usePageMeta(newsPage.meta);
  const [params, setParams] = useSearchParams();
  const active = IDS.includes(params.get("filter")) ? params.get("filter") : "all";
  const list = active === "all" ? newsItems : newsItems.filter((n) => n.category === active);
  const select = (id) => setParams(id === "all" ? {} : { filter: id }, { replace: true });

  return (
    <>
      <PageHero hero={newsPage.hero} testId="news-hero" />
      <section className="pb-24 sm:pb-32" data-testid="news-section">
        <div className="container-x">
          <FilterTabs filters={newsFilters} active={active} onSelect={select} countFor={countFor} label="Filter news" testIdPrefix="news" />
          <div className="mt-10 border-b border-line" data-testid="news-list">
            <AnimatePresence mode="popLayout" initial={false}>
              {list.map((n) => (
                <NewsCard key={n.id} n={n} />
              ))}
            </AnimatePresence>
          </div>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
